"use client";

// src/responsive.tsx
import * as React from "react";
import { Stack } from "@stepstone-genesis/components-stack";
import { Text } from "@stepstone-genesis/components-text";
import { useActiveBreakpoint } from "@stepstone-genesis/hooks-use-active-breakpoint";
import { useSSR } from "@stepstone-genesis/hooks-use-ssr";
import { __DEV__ } from "@stepstone-genesis/utilities";
import { Base } from "@stepstone-genesis/system";
var Responsive = ({
  children,
  at,
  below,
  belowOrEqualTo,
  above,
  aboveOrEqualTo,
  when,
  between,
  betweenOrEqualTo,
  debug
}) => {
  var _a;
  const { isActiveKey, matched, styles } = useActiveBreakpoint({
    below,
    belowOrEqualTo,
    above,
    aboveOrEqualTo,
    when,
    between,
    betweenOrEqualTo,
    at
  });
  const { isBrowser } = useSSR();
  const renderChildren = React.useMemo(
    () => debug && __DEV__ ? /* @__PURE__ */ React.createElement(Stack, { direction: "horizontal", spacing: "spaceXs" }, children, /* @__PURE__ */ React.createElement(Text, { color: "colorStatusNegativeDefault" }, ": Current breakpoint key: [", isBrowser ? isActiveKey : "server", "]")) : children,
    [children, isActiveKey, debug, isBrowser]
  );
  const renderServer = React.useMemo(() => {
    if (isBrowser) return null;
    return /* @__PURE__ */ React.createElement(Base, { __root: { display: styles } }, renderChildren);
  }, [renderChildren, isBrowser, styles]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, (_a = renderServer != null ? renderServer : matched && renderChildren) != null ? _a : null);
};
export {
  Responsive
};
